<app-header-toolbar [title]="pageTitle">
    <ion-buttons>
        <ion-button (click)="showMap = !showMap"
                    [class.btn-selected]="showMap">
            <ion-icon name="map-outline"></ion-icon>
        </ion-button>

<!--        <ion-button *ngIf="hasLidar$ | async"-->
<!--                    (click)="showLidar = !showLidar"-->
<!--                    [class.btn-selected]="showLidar">-->
<!--            <ion-icon name="radio-outline"></ion-icon>-->
<!--        </ion-button>-->

        <ion-button (click)="showDeepZoom = !showDeepZoom"
                    [class.btn-selected]="showDeepZoom">
            <ion-icon name="image-outline"></ion-icon>
        </ion-button>
    </ion-buttons>
</app-header-toolbar>

<ion-content [scrollY]="false"
             [scrollX]="false">
    <div class="content-wrapper">
        <div class="left-panel">
            <app-pole-details [poleList]="(inspectionService.currentPoleList$ | async)">
            </app-pole-details>
        </div>
        <div class="center-panel splitter">
            <div *ngIf="!showMap && !showDeepZoom"
                 class="nothing-selected-panel">
                Select the
                <ion-icon name="map-outline"></ion-icon>
                Map and/or
                <ion-icon name="image-outline"></ion-icon>
                Image icon above to display the map and/or image.
            </div>
            <as-split *ngIf="showMap || showDeepZoom || showLidar"
                      direction="horizontal">
                <as-split-area *ngIf="showMap"
                               [order]="0"
                               size="50">
                    <div class="map-container">
                        <app-map-viewer [poleList]="(inspectionService?.currentPoleList$ | async)">
                        </app-map-viewer>
                    </div>
                </as-split-area>

<!--                <as-split-area *ngIf="showLidar"-->
<!--                               [order]="0"-->
<!--                               size="50">-->
<!--                    <div class="lidar-container">-->
<!--                        <app-lidar-wrapper-->
<!--                            [currentStructure]="((inspectionService?.currentPoleList$ | async)?.currentPoleItem$ | async)">-->
<!--                        </app-lidar-wrapper>-->
<!--                    </div>-->
<!--                </as-split-area>-->

                <as-split-area *ngIf="showDeepZoom"
                               [order]="1"
                               size="50">
                    <div class="tab-content-container">
                        <app-open-sea-dragon
                            [poleImage]="(inspectionService?.currentPoleList?.currentPoleImage$ | async)"
                            [viewMode]="viewMode$ | async"
                            (cropAreaSelected)="selectedCropArea($event)"
                            (areaSelected)="selectedArea($event)">
                        </app-open-sea-dragon>
                    </div>
                </as-split-area>
            </as-split>

        </div>

        <div class="right-panel">
            <div class="images-wrapper">
                <app-pole-list-item-images [poleItem]="inspectionService?.currentPoleList?.currentPoleItem$ | async"
                                           [viewMode]="viewMode$ | async"
                                           [viewContent]="viewContent$ | async"
                                           [currentInspectionBatch]="(inspectionService.currentInspectionBatch$ | async)"
                                           (selectedPoleImage)="poleImageSelected($event)"
                                           (selectedPoleImageIsReadOnly)="poleImageSelectedIsReadOnly($event)">
                </app-pole-list-item-images>

                <!--                <app-pole-list-item-images-by-batch [poleItem]="inspectionService?.currentPoleList?.currentPoleItem$ | async"-->
                <!--                                                    [viewMode]="'FULL_VIEW'"-->
                <!--                                                    [hideInspectionBatchID]="(inspectionService.currentInspectionBatch$ | async)?.id"-->
                <!--                                                    (selectedPoleImage)="poleImageSelected($event)">-->
                <!--                </app-pole-list-item-images-by-batch>-->
            </div>
        </div>

        <div class="bottom-panel">
            <div class="display-wrapper">
                <ion-segment mode="ios" (ionChange)="segmentChanged($event)" value="filter">
                    <ion-segment-button value="filter"
                                        layout="icon-start">
                        <ion-icon class="filter-icon" name="funnel-outline"></ion-icon>
                        <ion-label>Filter</ion-label>
                    </ion-segment-button>
                    <ion-segment-button value="sort"
                                        layout="icon-start">
                        <ion-icon class="filter-icon" name="swap-horizontal-outline"></ion-icon>
                        <ion-label>Sort</ion-label>
                    </ion-segment-button>
                </ion-segment>

                <div #filterWrapper
                     *ngIf="(displayMode$ | async) === 'filter'"
                     class="filter-wrapper">
                    <ng-select class="batch-selector"
                               [items]="(inspectionService.currentPoleList$ | async)?.filterTypes"
                               bindLabel="label"
                               bindValue="id"
                               autofocus
                               [searchable]="false"
                               [clearable]="false"
                               [(ngModel)]="filterType">
                    </ng-select>

                    <ng-select class="batch-selector"
                               *ngIf="(filterType$ | async) === 'FILTER_CANT_INSPECT' && viewMode !== 'CLIENT_VIEW'"
                               [items]="(inspectionService.currentPoleList$ | async)?.filterCantInspectTypes"
                               bindLabel="label"
                               bindValue="id"
                               autofocus
                               [searchable]="false"
                               [clearable]="false"
                               [(ngModel)]="filterSubType">
                    </ng-select>

                    <div class="input-wrapper"
                         [hidden]="hideFilterText">
                        <ion-input #filterTextInput
                                   (ionChange)="updateFilterText($event)"
                                   (ionFocus)="onInputFocus()"
                                   (ionBlur)="onInputBlur()"
                                   debounce="150"
                                   [(ngModel)]="filterText">
                        </ion-input>
                    </div>
                </div>
                <div #sortWrapper
                     *ngIf="(displayMode$ | async) === 'sort'"
                     class="sort-wrapper">
                    <ng-select class="batch-selector"
                               [items]="(inspectionService.currentPoleList$ | async)?.sortTypes"
                               bindLabel="label"
                               bindValue="id"
                               autofocus
                               [searchable]="false"
                               [clearable]="false"
                               [(ngModel)]="sortType">
                    </ng-select>
                </div>

            </div>

            <div class="pole-list-container">
                <div class="back-forward-buttons ion-activatable ripple-parent"
                     (click)="prevPoleWithEvent($event)">
                    <ion-ripple-effect></ion-ripple-effect>
                    <ion-icon name="caret-back"></ion-icon>
                </div>

                <div class="pole-list-wrapper">
                    <aas-pole-list [poleList]="(inspectionService?.currentPoleList$ | async)"
                                   [viewMode]="viewMode$ | async">
                    </aas-pole-list>
                </div>

                <div class="back-forward-buttons ion-activatable ripple-parent"
                     (click)="nextPoleWithEvent($event)">
                    <ion-ripple-effect></ion-ripple-effect>
                    <ion-icon name="caret-forward"></ion-icon>
                </div>
            </div>

            <div class="cropping-buttons-container"
                 *ngIf="(viewMode$ | async) === 'CROPPING' &&
                 inspectionService?.currentPoleList?.currentPoleItem$ | async as poleItem">
                <ion-button (click)="inspectionService.markShotFraming(0)"
                            size="small"
                            class="smallest">
                    0 - Unset
                </ion-button>
                <ion-button (click)="inspectionService.markSide(0)"
                            size="small"
                            class="smallest">
                    &#8679; 0 - Unset
                </ion-button>
                <ion-button (click)="inspectionService.markShotFraming(1)"
                            size="small"
                            class="smallest">
                    1 - Overview
                </ion-button>
                <ion-button (click)="inspectionService.markSide(1)"
                            size="small"
                            class="smallest">
                    &#8679; 1 - Front
                </ion-button>
                <ion-button (click)="inspectionService.markShotFraming(2)"
                            size="small"
                            class="smallest">
                    2 - Top Third
                </ion-button>
                <ion-button (click)="inspectionService.markSide(2)"
                            size="small"
                            class="smallest">
                    &#8679; 2 - Back
                </ion-button>
                <ion-button (click)="inspectionService.markReflight()"
                            size="small"
                            class="smallest"
                            [disabled]="inspectionService.currentPoleList?.currentPoleItem?.poleReflyStatus !== 'NO_NOTES'">
                   R - Refly
                </ion-button>
                <ion-button (click)="inspectionService.markNoReflight()"
                            size="small"
                            class="smallest"
                            [disabled]="inspectionService.currentPoleList?.currentPoleItem?.poleReflyStatus !== 'NO_NOTES'">
                    D - Don't Refly
                </ion-button>

<!--                <ion-button (click)="inspectionService.markShotFraming()"-->
<!--                            [disabled]="selectedPoleImageIsReadOnly === true"-->
<!--                            size="small">-->
<!--                    Back Overview-->
<!--                </ion-button>-->
<!--                <ion-button (click)="inspectionService.markShotFraming()"-->
<!--                            [disabled]="selectedPoleImageIsReadOnly === true"-->
<!--                            size="small">-->
<!--                    Back Top 1/3-->
<!--                </ion-button>-->
            </div>

            <!--            <div class="defect-buttons-container"-->
            <!--                 *ngIf="(viewMode$ | async) === 'INSPECT' && inspectionService?.currentPoleList?.currentPoleItem$ | async as poleItem">-->
            <!--                <ion-button (click)="inspectionService.certifyNoDefect()"-->
            <!--                            size="small"-->
            <!--                            [disabled]="(poleItem?.pole$ | async)?.id !== '00000000-0000-0000-0000-000000000000' && (poleItem?.poleStatus$ | async) !== poleItem?.statics.NO_NOTES">-->
            <!--                    Certify No Defect-->
            <!--                </ion-button>-->
            <!--                <ion-button (click)="inspectionService.declareCantInspect()"-->
            <!--                            size="small"-->
            <!--                            [disabled]="(poleItem?.pole$ | async)?.id !== '00000000-0000-0000-0000-000000000000' && (poleItem?.poleStatus$ | async) !== poleItem?.statics.NO_NOTES">-->
            <!--                    Declare Can't Inspect-->
            <!--                </ion-button>-->
            <!--                <ion-button (click)="inspectionService.addDefectNote()"-->
            <!--                            size="small"-->
            <!--                            [disabled]="(poleItem?.pole$ | async)?.id !== '00000000-0000-0000-0000-000000000000' && !((poleItem?.poleStatus$ | async) === poleItem?.statics.NO_NOTES || (poleItem?.poleStatus$ | async) === poleItem?.statics.HAS_DEFECTS)">-->
            <!--                    Create Defect Note-->
            <!--                </ion-button>-->
            <!--            </div>-->
        </div>
    </div>

    <!--    <ion-fab vertical="top" horizontal="end" slot="fixed">-->
    <!--        <ion-fab-button (click)="inspectionService.clearBatches()">-->
    <!--            <ion-icon name="add"></ion-icon>-->
    <!--        </ion-fab-button>-->
    <!--    </ion-fab>-->

</ion-content>
